// Mirrors backend/constants/prescription.js — these strings travel as query
// params and request bodies, so the two files must stay in step.

export const MEDICINE_FORM = {
  TABLET: "tablet",
  CAPSULE: "capsule",
  SYRUP: "syrup",
  INJECTION: "injection",
  OINTMENT: "ointment",
  DROPS: "drops",
  INHALER: "inhaler",
  OTHER: "other",
};

export const MEDICINE_FORM_LABEL = {
  [MEDICINE_FORM.TABLET]: "Tablet",
  [MEDICINE_FORM.CAPSULE]: "Capsule",
  [MEDICINE_FORM.SYRUP]: "Syrup",
  [MEDICINE_FORM.INJECTION]: "Injection",
  [MEDICINE_FORM.OINTMENT]: "Ointment",
  [MEDICINE_FORM.DROPS]: "Drops",
  [MEDICINE_FORM.INHALER]: "Inhaler",
  [MEDICINE_FORM.OTHER]: "Other",
};

export const CLINICAL_TERM_TYPE = {
  DIAGNOSIS: "diagnosis",
  SYMPTOM: "symptom",
};

export const CLINICAL_TERM_TYPE_LABEL = {
  [CLINICAL_TERM_TYPE.DIAGNOSIS]: "Diagnosis",
  [CLINICAL_TERM_TYPE.SYMPTOM]: "Symptom",
};

export const DOSAGE_TIMING = {
  BEFORE_FOOD: "before_food",
  AFTER_FOOD: "after_food",
  ANYTIME: "anytime",
};

export const DOSAGE_TIMING_LABEL = {
  [DOSAGE_TIMING.BEFORE_FOOD]: "Before food",
  [DOSAGE_TIMING.AFTER_FOOD]: "After food",
  [DOSAGE_TIMING.ANYTIME]: "Anytime",
};

export const DURATION_UNIT = {
  DAYS: "days",
  WEEKS: "weeks",
};

export const DURATION_UNIT_LABEL = {
  [DURATION_UNIT.DAYS]: "day(s)",
  [DURATION_UNIT.WEEKS]: "week(s)",
};

export const PRESCRIPTION_STATUS = {
  DRAFT: "draft",
  COMPLETED: "completed",
};

export const PRESCRIPTION_STATUS_LABEL = {
  [PRESCRIPTION_STATUS.DRAFT]: "Draft",
  [PRESCRIPTION_STATUS.COMPLETED]: "Completed",
};

// Common dosage frequency patterns a doctor can pick with one click instead
// of typing "1-0-1" every time; "Custom" falls through to free text.
export const DOSAGE_QUICK_PICKS = ["1-0-1", "1-1-1", "1-0-0", "0-0-1", "0-1-0", "1-1-1-1"];

export const calculateAge = (dob) => {
  if (!dob) return null;
  const birth = new Date(dob);
  if (Number.isNaN(birth.getTime())) return null;
  const today = new Date();
  let age = today.getFullYear() - birth.getFullYear();
  const monthDiff = today.getMonth() - birth.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) age--;
  return age;
};
